<!-- <div class="standardpanel">
  <div class="titleblock">
    <h3 class="title1level">Documentazione Allegata Fascicolo</h3>
  </div>
  <div class="container_dati_generali">
    <div class="row">
      <div class="col-sm-6">
        <app-treeview-component [treeModel]="navigatorTreeModel"
                                [showFileDetail]="false"
                                [itemSelected]="navigatorItemSelected"
                                (onItemSelected)="updateNavigatorItemSelected($event)"
                                [refreshData]="navigatorRefreshData"
                                (setRefreshData)="updateNavigatorRefreshData($event)"
        ></app-treeview-component>
      </div>
      <div class="col-sm-6" [ngSwitch]="navigatorStateValue">
        <app-detail-folder-file *ngSwitchCase="navigatorState.DETAILS"
                                [minervaWizard]="true"
                                [separatorePathLogico]="navigatorPathSeparator"
                                [itemSelected]="navigatorItemSelected"
                                (updateItemSelected)="updateNavigatorItemSelected($event)"
                                [refreshData]="navigatorRefreshData"
                                (setRefreshData)="updateNavigatorRefreshData($event)"
                                [addDocFormTitles]="navigatorAddDocFromTitle"
                                (onClickAddFolder)="onClickAddFolder($event)"
                                (onClickAddDocument)="onClickAddDocument($event)"
                                (onClickMoveDocument)="onClickMoveDocument($event)"
                                (onClickRemoveDocument)="onClickRemoveDocument($event)"
                                (from)="onDragMoveDocument($event)"
                                (to)="onDropMoveDocument($event)"
                                (onGoSectionRoot)="onGoSectionRoot($event)"
                                (onGoSectionChild)="onGoSectionChild($event)"
        ></app-detail-folder-file>
        <new-document-form *ngSwitchCase="navigatorState.ADD_DOCUMENT"
                               [tipiDocumento]="tipiDocumento"
                               [tipiProvenienza]="tipiProvenienza"
                               (onReturnCallback)="onAddDocument($event)"
        ></new-document-form>
        <add-folder-form *ngSwitchCase="navigatorState.ADD_FOLDER"
                             [tipiDocumento]="tipiDocumento"
                             [tipiProvenienza]="tipiProvenienza"
                             (onReturnCallback)="onAddDocument($event)"
        ></add-folder-form>
      </div>
    </div>
  </div>
</div> -->
<div class="standardpanel">
  <div class="titleblock" style="margin-bottom: 25px;">
    <h3 class="title1level">Documentazione allegata fascicolo</h3>
  </div>
  <div class="row" style="background-color: #fff;  margin: 1px; margin-top: 74px;">
    <div class="loading-content" *ngIf="loading">
      <div class="spinner-border" role="status" >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="col-md-4">
      <app-treeview-component [treeModel]="demoData"
                              [showFileDetail]="false"
                              [refreshData]="refreshData"
                              [itemSelected]="itemSelected"
                              (setRefreshData)="setRefreshData($event)"
                              (onItemSelected)="setItemSelected($event)"
                              (onClickMoveDocument)="displayMoveDocModal($event, itemSelected.section)"
                              (from)="from($event)" (to)="to($event)"
                              (onUploadFileService)="uploadFileService($event)"></app-treeview-component>
    </div>
    <div class="col-md-8">
      <app-detail-folder-file
        [itemSelected]="itemSelected"
        [addDocFormTitles]="addDocFormTitles"
        [separatorePathLogico]="separatorePathLogico"
        [refreshData]="refreshData"
        (setRefreshData)="setRefreshData($event)"
        (onReturnUpdate)="refresh($event)"
        (onClickUpdateDocVersion)="displayDocVersionUpdateModal($event)"
        (onClickShowVersionHistory)="displayDocVersionHistoryModal($event)"
        (onClickAddDocument)="displayAddDocModal($event)"
        (exportFile)= "exportFile($event)"
        (onClickAddFolder)="displayAddFolderModal($event, itemSelected.section)"
        (onClickMoveDocument)="displayMoveDocModal($event, itemSelected.section)"
        (onClickRemoveDocument)="removeDocFromSezione($event, itemSelected.section)"
        (onClickRemoveDocumentWithFascicolo)="removeDocFromSezioneConFascicolo($event, itemSelected.section)"
        (esn)="getSezione($event)"
        (onClickUpdateMetadatiModal)="displayDocUpdateMetadatiModal($event)"
        (from)="from($event)" (to)="to($event)"
        (onGoSectionRoot)="goSectionRoot($event)" (onGoSectionChild)="goSectionChild($event)"
        (updateItemSelected)="itemSelected = $event"
        (onUploadFileService)="uploadFileService($event)"
        (onOpenProtocolDocSelection)="openProtocolDocumentsSelection($event)"
        #detailFolder [fascicolo]="fascicolo"
        (onDocSigned)="retrieveEventDocSigned($event)"
        (annullaEvent)="handleAnnullamento($event)"></app-detail-folder-file>
    </div>
  </div>
</div>

<div doc_sposta_categoria_modal #docSpostaModal [attr.id]="'docSpostaModal'" (onSelect)="onSelectCategoriaDocumento($event)" (onReturn)="refresh($event)"></div>
<div
  doc_version_update_modal #docVersionUpdateModal	[fascicolo]="fascicolo"
  [tipoPratica]="tipoPratica" [attr.id]="'docVersionUpdateModal'"
  (onReturn)="refresh($event)" style="width: 80%;"></div>
<div
  doc_version_history_modal #docVersionHistory [attr.id]="'docVersionHistory'"
  [tipoPratica]="getTipoPratica().id"></div>
<div [attr.id]="'docAddModal'" [fascicolo]="fascicolo" style="width: 100%;height: 100vh;margin: 0px;"
  doc_add_modal #docAddModal (onReturn)="refresh($event)" (onReturnSpostaDoc)="onDocumentoSpostato($event)"></div>

<!-- </div> -->
<div doc_protocol_modal #docProtocolModal [attr.id]="'docProtocolModal'"
(onReturn)="refresh($event)"></div>